import { render, staticRenderFns } from "./minrent.vue?vue&type=template&id=6124c7ef&scoped=true&"
import script from "./minrent.vue?vue&type=script&lang=js&"
export * from "./minrent.vue?vue&type=script&lang=js&"
import style0 from "./minrent.vue?vue&type=style&index=0&id=6124c7ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6124c7ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6124c7ef')) {
      api.createRecord('6124c7ef', component.options)
    } else {
      api.reload('6124c7ef', component.options)
    }
    module.hot.accept("./minrent.vue?vue&type=template&id=6124c7ef&scoped=true&", function () {
      api.rerender('6124c7ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PVv6PT5ZrRrJ/JS/comp/minrent.vue"
export default component.exports